/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Props {
  className: any;
}

export const PieChart022 = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2004_838)">
        <path
          d="M14.3334 11.6667C14.5642 11.6667 14.6797 11.6667 14.7732 11.718C14.8504 11.7603 14.9222 11.8397 14.9566 11.9207C14.9982 12.0189 14.9877 12.1233 14.9668 12.3323C14.8581 13.4157 14.4852 14.4596 13.8765 15.3705C13.144 16.4669 12.1028 17.3213 10.8846 17.8259C9.66647 18.3305 8.32602 18.4625 7.03282 18.2053C5.73961 17.9481 4.55172 17.3131 3.61937 16.3808C2.68702 15.4484 2.05208 14.2605 1.79485 12.9673C1.53761 11.6741 1.66964 10.3337 2.17422 9.1155C2.67881 7.89733 3.53329 6.85614 4.62962 6.1236C5.54055 5.51493 6.58446 5.14206 7.66784 5.03336C7.87681 5.0124 7.98129 5.00191 8.07948 5.04357C8.16049 5.07794 8.23988 5.14977 8.28216 5.22693C8.33342 5.32048 8.33342 5.4359 8.33342 5.66673V11.0001C8.33342 11.2334 8.33342 11.3501 8.37883 11.4392C8.41878 11.5176 8.48252 11.5814 8.56092 11.6213C8.65005 11.6667 8.76673 11.6667 9.00009 11.6667H14.3334Z"
          stroke="url(#paint0_linear_2004_838)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M14.3334 11.6667C14.5642 11.6667 14.6797 11.6667 14.7732 11.718C14.8504 11.7603 14.9222 11.8397 14.9566 11.9207C14.9982 12.0189 14.9877 12.1233 14.9668 12.3323C14.8581 13.4157 14.4852 14.4596 13.8765 15.3705C13.144 16.4669 12.1028 17.3213 10.8846 17.8259C9.66647 18.3305 8.32602 18.4625 7.03282 18.2053C5.73961 17.9481 4.55172 17.3131 3.61937 16.3808C2.68702 15.4484 2.05208 14.2605 1.79485 12.9673C1.53761 11.6741 1.66964 10.3337 2.17422 9.1155C2.67881 7.89733 3.53329 6.85614 4.62962 6.1236C5.54055 5.51493 6.58446 5.14206 7.66784 5.03336C7.87681 5.0124 7.98129 5.00191 8.07948 5.04357C8.16049 5.07794 8.23988 5.14977 8.28216 5.22693C8.33342 5.32048 8.33342 5.4359 8.33342 5.66673V11.0001C8.33342 11.2334 8.33342 11.3501 8.37883 11.4392C8.41878 11.5176 8.48252 11.5814 8.56092 11.6213C8.65005 11.6667 8.76673 11.6667 9.00009 11.6667H14.3334Z"
          stroke="url(#paint1_linear_2004_838)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="0.16"
          strokeWidth="1.5"
        />
        <path
          d="M11.6668 2.33339C11.6668 2.10256 11.6668 1.98714 11.718 1.89359C11.7603 1.81643 11.8397 1.7446 11.9207 1.71023C12.0189 1.66857 12.1234 1.67905 12.3323 1.70001C13.856 1.85285 15.2884 2.52698 16.3808 3.61935C17.4732 4.71172 18.1473 6.14414 18.3001 7.66781C18.3211 7.87679 18.3316 7.98127 18.2899 8.07947C18.2555 8.16047 18.1837 8.23986 18.1066 8.28214C18.013 8.33339 17.8976 8.33339 17.6668 8.33339L12.3334 8.33339C12.1001 8.33339 11.9834 8.33339 11.8943 8.28798C11.8159 8.24803 11.7521 8.18429 11.7122 8.10589C11.6668 8.01676 11.6668 7.90008 11.6668 7.66673V2.33339Z"
          stroke="url(#paint2_linear_2004_838)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M11.6668 2.33339C11.6668 2.10256 11.6668 1.98714 11.718 1.89359C11.7603 1.81643 11.8397 1.7446 11.9207 1.71023C12.0189 1.66857 12.1234 1.67905 12.3323 1.70001C13.856 1.85285 15.2884 2.52698 16.3808 3.61935C17.4732 4.71172 18.1473 6.14414 18.3001 7.66781C18.3211 7.87679 18.3316 7.98127 18.2899 8.07947C18.2555 8.16047 18.1837 8.23986 18.1066 8.28214C18.013 8.33339 17.8976 8.33339 17.6668 8.33339L12.3334 8.33339C12.1001 8.33339 11.9834 8.33339 11.8943 8.28798C11.8159 8.24803 11.7521 8.18429 11.7122 8.10589C11.6668 8.01676 11.6668 7.90008 11.6668 7.66673V2.33339Z"
          stroke="url(#paint3_linear_2004_838)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="0.16"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_2004_838"
          x1="-5.93949"
          x2="10.2325"
          y1="10.2474"
          y2="26.4194"
        >
          <stop stopColor="#7549F4" />
          <stop offset="1" stopColor="#FCA6E9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_2004_838"
          x1="9.99263"
          x2="9.99263"
          y1="1.68164"
          y2="18.3334"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_2004_838"
          x1="-5.93949"
          x2="10.2325"
          y1="10.2474"
          y2="26.4194"
        >
          <stop stopColor="#7549F4" />
          <stop offset="1" stopColor="#FCA6E9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_2004_838"
          x1="9.99263"
          x2="9.99263"
          y1="1.68164"
          y2="18.3334"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_2004_838">
          <rect fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
};
